import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const imgUrl = (path) => (path?.startsWith("/api/") ? `${BACKEND_URL}${path}` : path);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return e?.message || "Something went wrong";
}

export function fileToB64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
